import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=4ab70ad2"
import script from "./AddLabel.vue?vue&type=script&lang=js"
export * from "./AddLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports